import { Geolocation } from "@capacitor/geolocation";
import { Preferences } from "@capacitor/preferences";
import { TextToSpeech } from "@capacitor-community/text-to-speech";

import axios from "axios";
export default {
  state: {
    filters: {
      category: null,
      island: null,
    },
    disclaimer: false || localStorage.getItem("disclaimer"),
    insets: null,

    location: {
      latitude: 0,
      longitude: 0,
    },

    languages: [
      {
        name: "Ελληνικά",
        engName: "Greek",
        code: "el",
      },

      {
        name: "English",
        engName: "English",
        code: "en",
      },

      {
        name: "Français",
        engName: "French",
        code: "fr",
      },

      {
        name: "Deutsch",
        engName: "German",
        code: "de",
      },

      {
        name: "Italiano",
        engName: "Italian",
        code: "it",
      },
    ],

    mobileLang: JSON.parse(localStorage.getItem("mobileLang")) || null,

    isLanguageSupported: null,
    isPlaying: false,
    sound: "1",
    autoPlayTTS: JSON.parse(localStorage.getItem("autoPlayTTS")) || null,

    snackbar: {
      open: false,
      text: null,
      color: null,
      top: false,
      timeoute: 3,
    },

    fcm: null,
  },

  mutations: {
    setInsets(state, insets) {
      state.insets = insets;
    },
    togglePlaying(state, isPlaying) {
      state.isPlaying = isPlaying;
    },

    getFcm(state, fcm) {
      state.fcm = fcm;
    },

    toggleSound(state, sound) {
      state.sound = sound?.toString();
    },

    getLocation(state, location) {
      state.location = location;
    },

    setFilters(state, filters) {
      state.filters = filters;
    },

    setAutoPlayTTS(state, autoPlayTTS) {
      state.autoPlayTTS = autoPlayTTS;
      localStorage.setItem("autoPlayTTS", autoPlayTTS);
    },

    setMobileLang(state, lang) {
      if (typeof lang == "string") {
        const langObj = state.languages.find((el) => el.code == lang);
        state.mobileLang = langObj;
        localStorage.setItem("mobileLang", JSON.stringify(langObj));

        axios.defaults.headers.common["Accept-Language"] = `${langObj.code}`;
      } else {
        state.mobileLang = lang;
        localStorage.setItem("mobileLang", JSON.stringify(lang));
        axios.defaults.headers.common["Accept-Language"] = `${lang.code}`;
      }
    },

    setIsLanguageSupported(state, isLanguageSupported) {
      state.isLanguageSupported = isLanguageSupported;
    },

    toggleSnackbar(state, snackbar) {
      state.snackbar = {
        ...state.snackbar,
        ...snackbar,
      };
    },
  },

  actions: {
    async isLanguageSupported({ commit, state }) {
      try {
        let isCodeIncluded = false;

        const { languages } = await TextToSpeech.getSupportedLanguages();
        for (let i = 0; i < languages.length; i++) {
          if (languages[i].includes(state.mobileLang.code)) {
            isCodeIncluded = true;
          }
        }
        commit("setIsLanguageSupported", isCodeIncluded);
      } catch (e) {
        throw e;
      }
    },

    async getLocation({ commit }) {
      try {
        const coordinates = await Geolocation.getCurrentPosition({
          enableHighAccuracy: true,
        });
        commit("getLocation", {
          latitude: coordinates.coords.latitude,
          longitude: coordinates.coords.longitude,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async toggleSound({ commit }, sound) {
      try {
        await Preferences.set({
          key: "sound",
          value: sound,
        });
        if (sound == 0) {
          await TextToSpeech.stop();
          commit("togglePlaying", false);
        }
        commit("toggleSound", sound);
      } catch (e) {
        throw e;
      }
    },
  },
};
